import {translateSiteText} from './SiteLanguage';
const rows={
 planlama:[
  ['Lokasyon ve hafta','Önce yetkili olduğunuz lokasyonu ve haftayı seçin. Arama, pozisyon ve reyon filtrelerini kullanarak personelleri daraltabilirsiniz.'],
  ['Plan oluşturma','Personelleri veya hücreleri seçip vardiya şablonu, izin ya da özel vardiya ekleyin. Kopyalama, yapıştırma ve geri alma araçlarıyla planı düzenleyebilirsiniz.'],
  ['Kaydetme','Değişiklikleri kontrol edip Kaydet düğmesine basın. Hata olursa kaydedildiğini varsaymayın; mesajı kontrol edip yeniden deneyin.']
 ],
 gunluk:[
  ['Günlük takip','Lokasyon ve günü seçin. Personelin planlanan vardiyasını, giriş ve çıkış saatlerini, izin ve gecikme durumunu inceleyin.'],
  ['Filtre ve detay','Arama ve durum filtreleriyle listeyi daraltın. Mola bilgilerine tıklayarak mola haklarını ve kullanılan süreleri görün.']
 ],
 puantaj:[
  ['Dönem seçimi','Haftalık veya aylık dönemi ve lokasyonu seçin. Personel, pozisyon ve reyon filtreleriyle ihtiyacınız olan kayıtları bulun.'],
  ['Çalışma detayları','Listeden personelin çalışma, fazla veya eksik sürelerini inceleyin. Detay düğmesi günlük kayıtları açar; onay yetkiniz varsa ilgili durumu seçip kaydedin.']
 ]
};
export function shiftHelp(kind,lang){return (rows[kind]||[]).map(([heading,text])=>({heading:translateSiteText(heading,lang),text:translateSiteText(text,lang)}));}
